import { createContext, useContext } from 'react';
const DragDropComponentsContext = /*#__PURE__*/createContext(undefined);
export const DragDropComponentsProvider = DragDropComponentsContext.Provider;
export const useDragDropComponentsContext = () => useContext(DragDropComponentsContext);